import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { Box, Spinner, Text } from "@chakra-ui/react";

export default function AuthCallback() {
  const auth = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) nav("/", { replace: true });
  }, [auth.isAuthenticated, nav]);

  if (auth.error) {
    return (
      <Box p={8}>
        <Text color="red.500">Sign-in error: {auth.error.message}</Text>
      </Box>
    );
  }
  return (
    <Box p={8}>
      <Spinner mr={3} />
      <Text as="span">Signing you in…</Text>
    </Box>
  );
}
